import { CDN_URL } from "@env";
import { TopGameTagTypes } from "./image-types/top-game-tag-types";

const TopGameTagAssets: TopGameTagTypes = {
  "img_0": CDN_URL + "/image-assets/animation-assets/top-game-tag/images/img_0.png",
};

export default TopGameTagAssets;
